/** Customer support contact details shown on user-facing error/recovery screens. */
export const SUPPORT_EMAIL = "support@storyboard.com";
export const SUPPORT_PHONE_DISPLAY = "(844) 619-0500";
/** E.164-ish form for `tel:` links. */
export const SUPPORT_PHONE_TEL = "+18446190500";
